<template>
  <div>
    <!-- editingUserBox style="color: #3d4d6b; width: 440px; margin: 10px auto 0 auto" -->
    <div class="editingUserBox">
      <ul style="text-align: center; padding: 20px; font-size: 18px">
        <li>{{ $t('component.EditingUser.pageTitle') }}</li>
      </ul>
      <ul class="invite-content" style="font-size: 14px">
        <li style="text-align: center; padding: 10px">
          <img :src="pictureBase64" style="width: 80px; height: 78px" />
        </li>
        <li style="text-align: center; padding: 10px">
          {{ shopOrmerchantName }}
        </li>
        <li style="text-align: center; padding: 10px">{{ userEmail }}</li>
        <li>
          <div>
            <ul>
              <li class="userInfoLi">
                <div>
                  {{ $t('shopListPage.contactList.firstName') }}:
                  {{ firstName }}
                </div>
                <div>
                  {{ $t('shopListPage.contactList.lastName') }}: {{ lastName }}
                </div>
              </li>
            </ul>
            <ul>
              <li class="userInfoLi">
                <div>
                  {{ $t('shopListPage.contactList.salutation') }}:
                  {{ salutation }}
                </div>
                <div>
                  <span
                    >{{ $t('shopListPage.contactList.phone') }}:
                    {{ phoneValue }}</span
                  >&nbsp;
                  <span
                    placeholder="Basic usage"
                    style="border: 0; width: 62%; height: 40px"
                    >{{ phone }}</span
                  >
                </div>
              </li>
            </ul>
            <ul>
              <li class="userInfoLi">
                <div>
                  {{ $t('shopListPage.contactList.title') }}: {{ title }}
                </div>
                <div>
                  <span
                    >{{ $t('shopListPage.contactList.mobile') }}:
                    {{ mobileValue }}</span
                  >&nbsp;
                  <span
                    placeholder="Basic usage"
                    style="border: 0; width: 62%; height: 39px"
                    >{{ mobile }}</span
                  >
                </div>
              </li>
            </ul>
            <ul>
              <li class="userInfoLi">
                <div>
                  <span
                    >{{ $t('component.EditUser.fax') }}:
                    {{ faxCountryCode }}</span
                  >&nbsp;
                  <span
                    placeholder="Basic usage"
                    style="border: 0; width: 62%; height: 39px"
                    >{{ faxValue }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li style="text-align: center; padding: 15px">
          <a-checkbox v-model:checked="receiveDailySummaryEmail" disabled>{{
            $t('component.EditingUser.receiveUsageReport')
          }}</a-checkbox>
        </li>
      </ul>
    </div>

    <div style="text-align: center; padding-top: 20px">
      <a-button
        type="primary"
        style="
          height: 38px;
          background: #f3f3f3;
          border-color: #f3f3f3;
          width: 180px;
          color: #172a4d;
        "
        disabled
        >{{ $t('component.EditingUser.verifying') }}</a-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditingUser',
  data() {
    return {
      size: 'large',
      firstName: '',
      lastName: '',
      salutation: '',
      phone: '',
      title: '',
      mobile: '',
      phoneValue: '',
      mobileValue: '',
      shopOrmerchantName: '',
      userEmail: '',
      receiveDailySummaryEmail: '',
      SalutationList: '',
      faxCountryCode: '',
      faxValue: ''
    };
  },
  created() {
    this.SalutationList = [
      { id: 1, name: 'Mr' },
      { id: 2, name: 'Mrs' },
      { id: 3, name: 'Miss' },
      { id: 4, name: 'Ms' },
      { id: 5, name: this.$t('component.EditUser.salutationNonDisclosure') }
    ];
  },
  mounted() {
    let user = this.$store.getters.get_user_Info_cache;
    if (user) {
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      let sal = this.SalutationList.find((p) => p.id == user.salutation);
      if (sal) this.salutation = sal.name;

      this.phone = user.phoneNumber;
      this.mobile = user.mobileNumber;
      this.title = user.title;
      this.phoneValue = user.phoneCountryCode;
      this.mobileValue = user.mobileCountryCode;
      this.shopOrmerchantName = user.isMerchant
        ? user.merchantName
        : user.shopName;
      this.userEmail = user.id;
      this.receiveDailySummaryEmail = user.receiveDailySummaryEmail;
      this.faxCountryCode = user.faxCountryCode;
      this.faxValue = user.fax;
    }
  },
  computed: {
    pictureBase64: function () {
      return this.$store.state.picture_Base64;
    }
  }
};
</script>

<style scoped>
.editingUserBox {
  color: #3d4d6b;
  width: 440px;
  margin: 10px auto 0 auto;
}

.invite-content {
  background-color: #c6cbd1;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
}

.userInfoLi {
  margin-bottom: 10px;
  display: flex;
}

.userInfoLi > div {
  height: 39px;
  width: 50%;
  text-align: center;
  line-height: 39px;
}

@media (max-width: 1240px) {
  .editingUserBox {
    width: 400px;
  }
  .userInfoLi {
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
  }

  .userInfoLi > div {
    min-height: 39px;
    word-break: normal;
    width: 98%;
    height: auto;
  }
}
@media (max-width: 412px) {
  .editingUserBox {
    width: 300px;
  }
}
</style>
